import { defaultLanguage } from "web/Layout/Translations/LanguageWrapper";

const changeMetaLang = (lang: string, defaultLang = defaultLanguage) => {
  const appDocument = document?.documentElement;

  switch (lang) {
    case "en_GB":
      appDocument.setAttribute("lang", "en");
      break;
    case "pl_PL":
      appDocument.setAttribute("lang", "pl");
      break;
    default:
      appDocument.setAttribute("lang", defaultLang);
  }
};

export default changeMetaLang;
